// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"7c4f9823","330":"a5bb640e","388":"639b3aed","396":"2baa1643","421":"0b95a458","655":"d3e4275c"}[chunkId] + ".chunk.css";
};